module.exports = __webpack_public_path__ + "static/media/20ECE13.a186d14c.jpg";